import _ from 'lodash'

export default {
	data() {
		return {
			
		}
	},
	props: [],
	created(){
		
	},
	methods: {
		
	},
	computed:{
		getTotalParcelleFavoris(){
			return this.$store.getters.getTotalParcelleFavoris
		},
	},
	components:{
		
	}
}